export default __webpack_public_path__ + "static/media/splash.2770e6c3.png";